class TopInterview {
  constructor(selector) {
    this.root = document.querySelector(selector);
    if (!this.root || typeof Swiper === 'undefined') return;

    this.sliderEl = this.root.querySelector('.js-topInterviewSlider');
    if (!this.sliderEl) return;

    this.mq = window.matchMedia('(max-width: 767px)');
    this.decoDelay = 300;
    this.decoTimer = null;
    this.resizeTimer = null;
    this.panelLink = this.root.querySelector('.js-topInterviewLink');
    this.nextEl = this.root.querySelector('.js-topInterviewNext');
    this.prevEl = this.root.querySelector('.js-topInterviewPrev');
    this.paginationEl = this.root.querySelector('.js-topInterviewPagination');
    this.slideCount = parseInt(this.root.dataset.slideCount, 10) || 5;
    this.spaceBetweenMobile = 24;
    this.originalSliderHtml = this.sliderEl.innerHTML;
    this.swiper = null;

    this.initSwiper();
    this.bindResize();
    this.mq.addEventListener('change', () => {
      this.reinitSwiper();
    });
  }

  getSwiperOptions() {
    return {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: this.spaceBetweenMobile,
      loop: true,
      loopedSlides: this.slideCount,
      speed: 600,
      autoHeight: false,
      watchSlidesProgress: false,
      roundLengths: true,
      updateOnWindowResize: false,
      observer: false,
      observeParents: false,
      allowTouchMove: true,
      navigation: {
        nextEl: this.nextEl,
        prevEl: this.prevEl,
      },
      pagination: {
        el: this.paginationEl,
        clickable: true,
        renderBullet: (index, className) =>
          `<span class="${className}"></span>`,
      },
      breakpoints: {
        768: {
          centeredSlides: false,
          spaceBetween: 30,
          slidesPerView: 'auto',
          autoHeight: true,
          watchSlidesProgress: true,
          updateOnWindowResize: true,
          allowTouchMove: false,
          simulateTouch: false,
        },
      },
      on: {
        init: () => {
          this.onSlideReady();
        },
        slideChangeTransitionStart: () => {
          if (!this.isMobile()) this.clearDeco();
        },
        slideChangeTransitionEnd: () => {
          this.onSlideReady();
        },
      },
    };
  }

  initSwiper(activeIndex = 0) {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    this.sliderEl.innerHTML = this.originalSliderHtml;
    this.swiper = new Swiper(this.sliderEl, this.getSwiperOptions());

    if (activeIndex > 0) {
      this.swiper.slideToLoop(activeIndex, 0, false);
    }

    if (this.isMobile()) {
      this.setMobileDeco();
    }
  }

  reinitSwiper() {
    const activeIndex = this.swiper ? this.swiper.realIndex : 0;
    if (!this.isMobile()) {
      this.clearDeco();
    }
    this.initSwiper(activeIndex);
  }

  bindResize() {
    this.lastWidth = window.innerWidth;

    window.addEventListener('resize', () => {
      if (this.resizeTimer) window.clearTimeout(this.resizeTimer);
      this.resizeTimer = window.setTimeout(() => {
        if (!this.swiper) return;

        const width = window.innerWidth;
        if (width === this.lastWidth) return;

        const crossedBreakpoint =
          (this.lastWidth < 768 && width >= 768) ||
          (this.lastWidth >= 768 && width < 768);

        this.lastWidth = width;

        if (crossedBreakpoint) {
          this.reinitSwiper();
          return;
        }

        if (this.isMobile()) {
          this.swiper.update();
          return;
        }

        this.reinitSwiper();
      }, 200);
    });
  }

  isMobile() {
    return this.mq.matches;
  }

  onSlideReady() {
    const activeSlide = this.sliderEl.querySelector('.swiper-slide-active');
    if (!activeSlide) return;

    this.updatePanel(activeSlide);

    if (this.isMobile()) return;

    this.clearDeco();
    this.showDeco();
  }

  setMobileDeco() {
    if (this.decoTimer) {
      window.clearTimeout(this.decoTimer);
      this.decoTimer = null;
    }

    this.root.querySelectorAll('.p-top__interview-visual').forEach((el) => {
      el.classList.add('is-deco-visible');
    });
  }

  showDeco() {
    const activeSlide = this.sliderEl.querySelector('.swiper-slide-active');
    if (!activeSlide) return;

    this.updatePanel(activeSlide);

    const visual = activeSlide.querySelector('.p-top__interview-visual');
    if (!visual) return;

    this.decoTimer = window.setTimeout(() => {
      visual.classList.add('is-deco-visible');
    }, this.decoDelay);
  }

  clearDeco() {
    if (this.decoTimer) {
      window.clearTimeout(this.decoTimer);
      this.decoTimer = null;
    }

    this.root.querySelectorAll('.p-top__interview-visual.is-deco-visible').forEach((el) => {
      el.classList.remove('is-deco-visible');
    });
  }

  updatePanel(slide) {
    const { url, label } = slide.dataset;

    if (this.panelLink) {
      this.panelLink.href = url || '#';
      if (label) this.panelLink.setAttribute('aria-label', label);
    }
  }
}
